import { Auth0Client, type Auth0ClientOptions, type User } from '@auth0/auth0-spa-js'
import { useEffect, useState } from 'react'

export const scopes =
  'openid profile user_metadata create:users read:users update:users delete:users read:roles read:categories update:categories delete:categories create:categories read:priorities update:priorities update:branding read:assets delete:assets update:assets create:assets'

export const authorizationParams = {
  audience: process.env.REACT_APP_AUTH0_AUDIENCE || '',
  scope: scopes,
  redirect_uri: `${process.env.REACT_APP_AUTH0_REDIRECT_URI}/callback`,
}

export const auth0Options: Auth0ClientOptions = {
  domain: process.env.REACT_APP_AUTH0_DOMAIN || '',
  clientId: process.env.REACT_APP_AUTH0_CLIENTID || '',
  authorizationParams,
}

export const auth0 = new Auth0Client(auth0Options)

export const getApiUrl = async () => {
  if (process.env.REACT_APP_API_URL) {
    return process.env.REACT_APP_API_URL
  }
  const claims = await auth0.getIdTokenClaims()
  return claims?.['https://gemsotec.com/apiv3'] ?? ''
}

export const login = async () => {
  await auth0.loginWithRedirect()
}

export const logout = async () => {
  await auth0.logout({
    logoutParams: {
      returnTo: process.env.REACT_APP_AUTH0_LOGOUT_REDIRECT_URI || window.location.origin,
    },
  })
}

export const useUser = () => {
  const [user, setUser] = useState<User | null>(null)
  const [loading, setLoading] = useState(true)
  useEffect(() => {
    auth0.getUser().then((user) => {
      setUser(user ?? null)
      setLoading(false)
    })
  }, [])
  return { user, loading }
}
